import {
  Description,
  Title,
} from "features/settings/CancelSubscription/styles.tsx";
import React from "react";
import styled, { css, useTheme } from "styled-components";
import { CircleAlert } from "lucide-react";
import { hexToRGB } from "@shared/utils/misc";
import { newLookPanel } from "features/settings/CancelSubscription/styles.tsx";
import {
  ConfirmDecisionMainIcon,
  ConfirmDecisionMainIconDark,
} from "features/settings/CancelSubscription/icons.tsx";
import useTypedTranslation from "@shared/common/i18n/useTypedTranslation.ts";
import { LanguageNameSpaces } from "@shared/types";

const AreYouSure = () => {
  const { t } = useTypedTranslation(LanguageNameSpaces.BILLING);
  const theme = useTheme();
  const { isDarkMode, isNewLook } = theme;
  const Icon = isDarkMode
    ? ConfirmDecisionMainIconDark
    : ConfirmDecisionMainIcon;

  return (
    <Wrapper>
      {isNewLook ? (
        <StatusIcon $color={theme.colors.gold}>
          <CircleAlert size={28} strokeWidth={1.75} />
        </StatusIcon>
      ) : (
        <Icon $size="240px" style={{ marginBottom: 20 }} />
      )}
      <Title>{t("cancel_subscription.confirm")}</Title>
      <Description
        style={{ marginBottom: 4, maxWidth: 450, textAlign: "center" }}
      >
        {t("cancel_subscription.turn_off_auto_renewal")}
      </Description>
      <Description>{t("cancel_subscription.are_you_sure")}</Description>
    </Wrapper>
  );
};

export default AreYouSure;

const StatusIcon = styled.span<{ $color: string }>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 60px;
  height: 60px;
  /* The 8px halo is drawn outside the box: 32px from the card top to the
     halo, 20px from the halo to the title. */
  margin: 8px auto 28px;
  border-radius: 50%;
  color: ${(p) => p.$color};
  background: ${(p) => hexToRGB(p.$color, 0.12)};
  box-shadow: 0 0 0 8px ${(p) => hexToRGB(p.$color, 0.06)};
`;
const Wrapper = styled.div`
  text-align: center;
  display: flex;
  flex-direction: column;
  align-items: center;
  ${(p) =>
    p.theme.isNewLook &&
    css`
      ${newLookPanel}
      padding-top: 32px;
      padding-bottom: 32px;
      && > :last-child {
        margin-bottom: 0;
      }
    `}
`;
